import {
  BaseQueryApi,
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { clearAll } from '@/features/auth/api/slice';
import { BaseApiUrl } from '@/constants';

const baseQuery = fetchBaseQuery({
  baseUrl: BaseApiUrl,
  prepareHeaders: async (headers, api) => {
    headers.set('Device-Name', navigator.userAgent);
    headers.set('Device-Id', crypto.randomUUID());

    // Electron identifies via App-Name; website is identified by the browser's Origin
    if (window.electron?.isElectron) {
      headers.set('App-Name', 'com.modulussell.windows');
    }

    if (api.endpoint !== "uploadFile") {
      headers.set('Content-Type', 'application/json');
    }
    return headers;
  },
  credentials: 'include',
});

export const baseQueryWithReAuth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: {},
) => {
  let result: any = await baseQuery(args, api, extraOptions);
  if (result?.error?.status === 401) {
    const refreshResult = await baseQuery(
      '/v1/auth/refresh-token',
      api,
      extraOptions,
    );
    if (refreshResult?.data) {
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(clearAll());
    }
  } else if (result?.error?.status === 409 && result.meta?.request.url.includes('auth')) {
    await baseQuery({ url: '/v1/auth/log-out', method: 'POST' }, api, extraOptions);
    api.dispatch(clearAll());
  }
  // if (result?.error) {
  //   if (api.endpoint == "sendOTP" && result.error.status == 409) {
  //     alert('Your email or phone number is Already verified');
  //     return result;
  //   }
  //   // todo add toast message here
  //   const { heading, message } = getErrorMessage(result.error.status)
  //   if (heading && message) {
  //     alert(`${heading}: ${result.error?.data?.message ?? message}`);
  //   }
  // }
  return result;
};
export const baseSplitApi = createApi({
  reducerPath: 'baseSplitApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: [
    'Notifications',
    'ExpenseList',
    'NotificationCount',
    'ProductList',
    'Product',
    'OrderList',
    'CustomerList',
    'LowStockCount',
    'DailySales',
    'OrderCount',
    'PaymentMethodList',
    'ExpenseServiceDetails',
    'StoreProfile',
    'StoreList',
    'ExpenseOrder',
    'CategoryList',
    'StockValue'
  ],
  endpoints: () => ({}),
});

type BaseQueryOptions = {
  url: string;
  searchParams?: string;
};
type BaseMutation = {
  url: string;
  searchParams?: string;
  body: any;
};
const baseApi = baseSplitApi.injectEndpoints({
  endpoints: builder => ({
    getBase: builder.query<any, BaseQueryOptions>({
      query: ({ url, searchParams }) => ({
        url: `/${url}?${searchParams ? searchParams : ''}`,
        method: 'GET',
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
    post: builder.mutation<any, BaseMutation>({
      query: ({ body, url, searchParams }) => ({
        url: `/${url}?${searchParams ? searchParams : ''}`,
        method: 'Post',
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
    update: builder.mutation<any, BaseMutation>({
      query: ({ body, url, searchParams }) => ({
        url: `/${url}?${searchParams ? searchParams : ''}`,
        method: 'Patch',
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
    delete: builder.mutation<any, BaseMutation>({
      query: ({ body, url, searchParams }) => ({
        url: `/${url}?${searchParams ? searchParams : ''}`,
        method: 'Post',
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
  }),
});

export const {
  useGetBaseQuery,
  useLazyGetBaseQuery,
  usePostMutation,
  useUpdateMutation,
  useDeleteMutation,
} = baseApi;


